import { createContext, useContext } from "react";
import { Check } from "lucide-react";
import { BrandText } from "./brand";

// True inside the agency portal shell: page headers drop the marketing scale.
const ShellCtx = createContext(false);
export const ShellProvider = ShellCtx.Provider;
export const useInShell = () => useContext(ShellCtx);

export function FeatureList({ features, prior, className = "", iconClass = "text-success-strong", size = "text-sm", testId }) {
  return (
    <ul className={`space-y-2 ${size} ${className}`} data-testid={testId}>
      {prior && <li className="flex items-start gap-2 font-semibold" data-testid={testId ? `${testId}-prior` : undefined}><Check className={`mt-0.5 h-4 w-4 shrink-0 ${iconClass}`} /> Everything in {prior}, plus:</li>}
      {features.map((f) => <li key={f} className="flex items-start gap-2"><Check className={`mt-0.5 h-4 w-4 shrink-0 ${iconClass}`} /> <span><BrandText>{f}</BrandText></span></li>)}
    </ul>
  );
}

export function SectionHeading({ eyebrow, title, desc, action, center, light }) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>

      <h2 className={`mt-3 font-display text-3xl sm:text-4xl leading-[1.08] tracking-tight ${light ? "text-primary-foreground" : "text-foreground"}`}><BrandText light={light}>{title}</BrandText></h2>
      {desc && <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-primary-foreground/75" : "text-muted-foreground"}`}><BrandText light={light}>{desc}</BrandText></p>}
      {action}
    </div>
  );
}

export function PageHeader({ eyebrow, title, desc, children }) {
  const compact = useInShell();
  return (
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${compact ? "pt-6" : "pt-10 sm:pt-14"}`}>
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div className="max-w-2xl">

          <h1 className={compact ? "text-2xl font-semibold leading-tight tracking-tight text-foreground sm:text-3xl" : "mt-3 font-display text-4xl sm:text-5xl leading-[1.12] sm:leading-[1.08] tracking-tight text-foreground"}><BrandText>{title}</BrandText></h1>
          {desc && <p className={compact ? "mt-2 text-sm text-label2" : "mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed"}><BrandText>{desc}</BrandText></p>}
        </div>
        {children}
      </div>
    </div>
  );
}

export function InsetList({ rows, testId }) {
  return (
    <dl className="inset-list overflow-hidden rounded-card bg-gray6" data-testid={testId}>
      {rows.map(([k, v]) => (
        <div key={k} className="flex items-center justify-between gap-4 px-4 py-3 text-sm"><dt className="text-label2"><BrandText>{k}</BrandText></dt><dd className="text-right font-medium">{v}</dd></div>
      ))}
    </dl>
  );
}
